import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import About from "@/components/landing/About";
import Products from "@/components/landing/Products";
import Gallery from "@/components/landing/Gallery";
import Clientele from "@/components/landing/Clientele";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="bg-white min-h-screen" data-testid="landing-page">
      <Navbar />
      <Hero />
      <About />
      <Products />
      <Gallery />
      <Clientele />
      <Contact />
      <Footer />
    </div>
  );
}
